import ModalEventBus from 'components/Modal/ModalEventBus';

export default {
  showImportFromCSVModal() {
    ModalEventBus.open({
      component: 'ImportFromCSVModal',
      componentProps: {
        handleCancel: () => {
          ModalEventBus.close();
        },
      },
    });
  },
};
